<script lang="ts" setup>
defineProps<{
  link: string
  title: string
}>()
</script>

<template>
  <NuxtLink
    class="
      flex items-center text-2xl font-medium leading-normal text-main-dark !no-underline
      transition-colors duration-300 ease-in-out hover:text-main-green
      md:text-[28px]
    "
    :to="link"
  >
    <span>{{ title }}</span>
    <SvgIcon class="!size-7" name="outlined/big-arrow-right" />
  </NuxtLink>
</template>
